<style scoped>
.tags .tag {
  color: var(--cl-black-80);
  padding: 8px 10px;
  border-radius: 3px;
  margin-right: 8px;
  line-height: 14px;
  height: 32px;
  user-select: none;
  background: #f3f3f3;
}
.tags .tag {
  margin-top: 8px;
}
</style>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
const props = defineProps(["tags"]);
useI18n();
function fallbackArray(arr?: string[]) {
  return arr?.length ? arr : [null];
}
</script>
<template>
  <div class="tags u-row">
    <div
      class="tag u-row"
      v-for="tag of fallbackArray(props.tags)"
      :key="tag ?? 'null'"
    >
      <span>{{ tag ?? "-" }}</span>
    </div>
  </div>
</template>
